import React from "react";
import { Progress as AntProgress } from "antd";

const Progress = ({ total, score }) => {
  return (
    <div className="progress">
      <AntProgress
        percent={(score / total) * 100}
        showInfo={false}
        strokeColor="#1890ff"
      />
      <span>{((score / total) * 100).toFixed(2)}%</span>
    </div>
  );
};

export default Progress;
